import { strategyToOptions } from "@/common/utils/strategyToOptions"

export const companySubGroupableKlass: Record<string, string> = {
  'Client::Card::Personal': 'Pessoal',
  'Client::Card::Fleet': 'Frota'
}

export const companySubGroupableKlassOptions = strategyToOptions(companySubGroupableKlass);
